<script>
import formdate from "@/router/views/FormComponet/formdate.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIyilestirme from "@/models/StrIyilestirme";
import moment from "moment";
export default {
  mixins: [Api, Sabit, StrIyilestirme],
  props: ["Id", "AddEdit", "Geldigiyer"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    formtextarea,
    formdate,
    BirimSecimi,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("StrIyilestirme", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.StrIyilestirmeData;
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIyilestirme");
            }
          });
        } else {
          this.Update("StrIyilestirme", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIyilestirmeData;
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIyilestirme");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrIyilestirmeBirim"
      size="lg"
      :title="this.AddEdit == 'Edit' ? 'Kaydı Düzenle' : 'Kayıt Ekle'"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <BirimSecimi
            :title="FormDataType.Birimids.FieldTitle"
            :sutun="'0'"
            :title_position="'mb-3'"
            :selected="FormData.Birimids"
            :labels_lg="'3'"
            :v="$v.FormData.Birimids"
            :multiple="true"
            :BirimTipId="null"
            @Secilmis_Idler="FormData.Birimids = $event"
          />
          <formtextarea
            class="col-md-6"
            :FormDataType="FormDataType.Gelistirme"
            :Value="FormData.Gelistirme"
            :v="$v.FormData.Gelistirme"
            @input="FormData.Gelistirme = $event"
          />
          <formtextarea
            class="col-md-6"
            :FormDataType="FormDataType.Iyilestirme"
            :Value="FormData.Iyilestirme"
            :v="$v.FormData.Iyilestirme"
            @input="FormData.Iyilestirme = $event"
          />

          <formdate
            class="col-md-6"
            :FormDataType="FormDataType.Iyilestirmetarih"
            :Value="FormData.Iyilestirmetarih"
            :v="$v.FormData.Iyilestirmetarih"
            @input="FormData.Iyilestirmetarih = $event"
          />
          <formdate
            class="col-md-6"
            :FormDataType="FormDataType.Bitistarihi"
            :Value="FormData.Bitistarihi"
            :v="$v.FormData.Bitistarihi"
            @input="FormData.Bitistarihi = $event"
          />
        </div>
        <button class="btn btn-primary" type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
